import { render, staticRenderFns } from "./PagePurchase.vue?vue&type=template&id=2a8636c8"
import script from "./PagePurchase.vue?vue&type=script&lang=js"
export * from "./PagePurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8636c8')) {
      api.createRecord('2a8636c8', component.options)
    } else {
      api.reload('2a8636c8', component.options)
    }
    module.hot.accept("./PagePurchase.vue?vue&type=template&id=2a8636c8", function () {
      api.rerender('2a8636c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/containers/PagePurchase.vue"
export default component.exports